import React, { useContext, useEffect, useRef, useState } from 'react';
import { useT } from '../../../../../../helpers/i18n';
import { useInViewport } from 'react-in-viewport';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';

import Checkers from '../../../../../../helpers/class/Checkers';
import * as appContext from '../../../../../AppContext';
import ServiceContent from '../../../partials/services/ServiceContent';
import {fetchBuilderSettingByKey} from "../../../../../../helpers/MethodHelper";
import SwipperWrapper from "../../../../properties/partials/SwipperWrapper";
import {Swiper} from "swiper/react";
import TabsContentWrapper from "../../../../properties/partials/TabsContentWrapper";

export default function Services ( props ) {
  const t = useT();
    const isPublicDomain = useSelector(state => state['appSettings']['isPublicDomain']); // props.isDesktop;
    const [publicDomain, setPublicDomain] = useState(1);

    const builderServicesLayout = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_services_layout')
    );

    useEffect(() => {
        setPublicDomain(isPublicDomain)
    }, [isPublicDomain, setPublicDomain])

    const config = {disconnectOnLeave: false};
    const options = {};
    const myRef = useRef();
    const {
        inViewport
    } = useInViewport(
        myRef,
        options,
        config,
        props
    );

    const [servicesArrayLoading, setServicesArrayLoading] = useState(true)
    const [servicesArray, setServicesArray] = useState([])

    const viewPortResult = [];
    if (!inViewport) {
        viewPortResult[0] =
            <div ref={myRef}>
                <Skeleton height={30} className="col-8 col-sm-5 col-md-3 b-rad-md mb-1"/>
                <Skeleton height={42} className="col-9 col-sm-7 col-md-5 b-rad-md mb-2"/>
                <Skeleton height={180} className="col-12 b-rad-lg"/>
            </div>
        ;
        viewPortResult[1] =
            <div ref={myRef}>
                <Skeleton height={30} className="col-8 col-sm-5 col-md-3 b-rad-md mb-1"/>
                <Skeleton height={42} className="col-9 col-sm-7 col-md-5 b-rad-md mb-2"/>
                <Skeleton height={180} className="col-12 b-rad-lg"/>
            </div>
        ;
        viewPortResult[2] =
            <div ref={myRef}>
                <Skeleton height={30} className="col-8 col-sm-5 col-md-3 b-rad-md mb-1"/>
                <Skeleton height={42} className="col-9 col-sm-7 col-md-5 b-rad-md mb-2"/>
                <Skeleton height={180} className="col-12 b-rad-lg"/>
            </div>
        ;
    } else {
        viewPortResult[0] =
            <div className="col-12">
                <p className="block-title m-t-40 hint-text no-margin">{t('property.services')}</p>
                <h2 className="m-t-5">{t('property.includedServices')}</h2>
                <ServiceContent type={'included'} services={props.services.included}/>
            </div>
        ;
        viewPortResult[1] =
            <div className="col-12">
                {/*<p className="block-title m-t-40 hint-text no-margin">{t('property.services')}</p>*/}
                <h2 className="m-t-5">
                    {
                        publicDomain == 1 ?
                            ''
                            :
                            props.page_title
                    }
                    &nbsp;{t('property.specialServices')}
                </h2>
                <ServiceContent type={'featured'} services={props.services.featured}/>
            </div>
        ;
        viewPortResult[2] =
            <div className="col-12">
                {/*<p className="block-title m-t-40 hint-text no-margin">{t('property.services')}</p>*/}
                <h2 className="m-t-5">{t('property.onRequest')}</h2>
                <ServiceContent type={'ondemand'} services={props.services.ondemand}/>
            </div>
        ;

    }

    const getTabbedContent = () => {
        let result = []
        if (Checkers.objChildExists(props.services, 'included') && props.services.included.length > 0) {
            result.push({
                tabId: "included",
                tabTitle: t('property.includedServices'),
                tabContent: <ServiceContent type={'included'} services={props.services.included}/>
            })
        }

        if (Checkers.objChildExists(props.services, 'featured') && props.services.featured.length > 0) {
            result.push({
                tabId: "featured",
                tabTitle: t('property.specialServices'),
                tabContent: <ServiceContent type={'featured'} services={props.services.featured}/>
            })

        }

        if (Checkers.objChildExists(props.services, 'ondemand') && props.services.ondemand.length > 0) {
            result.push({
                tabId: "ondemand",
                tabTitle: t('property.onRequest'),
                tabContent: <ServiceContent type={'ondemand'} services={props.services.ondemand}/>
            })
        }

        setServicesArrayLoading(false)

        setServicesArray(result)
    }

    useEffect(() => {
        if (servicesArrayLoading) {
            getTabbedContent()
        }
    }, [])

    return (
        <>
            {
                builderServicesLayout == "tabs" ?
                    <>
                        <div id={props.isManager ? "pro_detail_services" : "services"} className="pb-5">
                            <p className="block-title m-t-40 hint-text no-margin p-l-10">{t('property.services')}</p>
                            <h2 className="m-t-5 p-l-10">{t('property.availableServices')}</h2>
                            <TabsContentWrapper data={servicesArray} ReactComponentsArrayLoading={servicesArrayLoading} responsiveDropdown={false}/>
                        </div>
                    </>
                    :
                    <div id={props.isManager ? undefined : "services"}>
                        {
                            Checkers.objChildExists(props.services, 'included') && props.services.included.length > 0 &&
                            <div id="pro_detail_services_included" className="pb-5">
                                <div className="row w-100 no-margin">
                                    {viewPortResult[0]}
                                </div>
                            </div>
                        }
                        {
                            Checkers.objChildExists(props.services, 'featured') && props.services.featured.length > 0 &&
                            <div id="pro_detail_services_featured" className="pb-5">
                                <div className="row w-100 no-margin">
                                    {viewPortResult[1]}
                                </div>
                            </div>
                        }
                        {
                            Checkers.objChildExists(props.services, 'ondemand') && props.services.ondemand.length > 0 &&
                            <div id="pro_detail_services_ondemand" className="pb-5">
                                <div className="row w-100 no-margin">
                                    {viewPortResult[2]}
                                </div>
                            </div>
                        }
                    </div>
            }
        </>
    )
}
